import { useState, useRef, useEffect, useCallback } from "react";
import { X } from "lucide-react";
import MapaInicioFin from "./mapa-inicio-fin";
import { obtenerInfoWorkflow } from "../api/api-workflow";
import { obtenerHistoricoRuta } from "../api/gestion-dts/api-historico";
import moment from "moment";

/**
 * Modal to display workflow items in tabs (Workflow + Historico).
 * Fetches historico only once when the modal becomes visible.
 */
export default function WorkflowModal({
    visible = false,
    items = [],
    onClose,
    t,
    rowSelected,
}) {
    const [activeTab, setActiveTab] = useState(0);
    const [fetchedItems, setFetchedItems] = useState(null);
    const [loading, setLoading] = useState(false);
    const [historicoCoords, setHistoricoCoords] = useState(null);
    const [inicioRuta, setInicioRuta] = useState(null);
    const [finRuta, setFinRuta] = useState(null);
    // const hasFetchedForOpenRef = useRef(false);

    useEffect(() => {
        // console.log('items');
        // console.log(items);
        // console.log('rowSelected');
        // console.log(rowSelected);
        if (visible === false) {
            // hasFetchedForOpenRef.current = false;
            return;
        }
        // if (hasFetchedForOpenRef.current) return;
        // hasFetchedForOpenRef.current = true;
        setActiveTab(0);
        fetchHistorico();
    }, [visible]);

    const tabs = [{ id: "historico", label: t("label_historico") }];


    const fetchHistorico = async () => {
        if (!rowSelected?.numeroDocumento) return;
        try {
            // console.log("fetchHistorico");
            // console.log(rowSelected);
            setLoading(true);
            const response = await obtenerInfoWorkflow({ numeroDocumento: rowSelected.numeroDocumento });
            // console.log("response");
            // console.log(response);
            if (response.error === false && response.data) {
                const { inicioRuta, finRuta } = response.data;
                // console.log("inicioRuta");
                // console.log(inicioRuta);
                // console.log("finRuta");
                // console.log(finRuta);
                const inicio = {
                    lat: inicioRuta.latitudInicio,
                    lng: inicioRuta.longitudInicio,
                };
                const fin = {
                    lat: finRuta.latitudFin,
                    lng: finRuta.longitudFin,
                };
                setInicioRuta(inicio);
                setFinRuta(fin);
                if (inicioRuta && finRuta) {
                    const objEnviar = {
                        placa: rowSelected.valuePlaca,
                        fechaHoraIni: moment(inicioRuta.fecha).format("DD/MM/YYYY HH:mm"),
                        fechaHoraFin: moment(finRuta.fecha).format("DD/MM/YYYY HH:mm"),
                    };
                    const historicoResponse = await obtenerHistoricoRuta(objEnviar);
                    // console.log("historicoResponse");
                    // console.log(historicoResponse);
                    // if (Array.isArray(historicoResponse) && historicoResponse.length > 0) {
                    setHistoricoCoords(historicoResponse);
                    // }
                }
            }
        } catch (err) {
            console.warn("WorkflowModal fetchHistorico err", err);
        } finally {
            setLoading(false);
        }
    };

    if (!visible) return null;

    const displayItems = fetchedItems !== null ? fetchedItems : items;

    const renderWorkflow = (item, index) => {
        const key = item.key || `item-${index}`;
        if (item.url && (item.type === "firma" || item.type === "fotografia")) {
            const label = item.type === "firma"
                ? ((t && t("label_firma_cliente")) || "Firma cliente")
                : ((t && t("label_foto_recibo")) || "Foto recibo");
            return (
                <div key={key} className="border border-gray-200 rounded-lg p-3 space-y-2">
                    <div className="text-sm font-medium text-gray-700">{item.key || label}</div>
                    <img src={item.url} alt={item.key || label} className="max-w-full max-h-48 object-contain rounded border border-gray-100" />
                </div>
            );
        }
        if (item.type === "estado_de_pago" && Array.isArray(item.estadoDePagoSelected)) {
            return (
                <div key={key} className="border border-gray-200 rounded-lg p-3 space-y-2">
                    <div className="text-sm font-medium text-gray-700">{(t && t("label_estado_pago")) || "Estado de pago"}</div>
                    <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                        {item.estadoDePagoSelected.map((opt, i) => (
                            <li key={i}>
                                {opt.descripcion}
                                {Array.isArray(opt.dynamicFields) && opt.dynamicFields.length > 0 && (
                                    <span className="text-gray-500"> ({opt.dynamicFields.map((f) => `${f.key || ""}: ${f.value}`).join(", ")})</span>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            );
        }
        if (item.type === "quien_recibe_entrega" && Array.isArray(item.quienRecibeEntregaSelected)) {
            return (
                <div key={key} className="border border-gray-200 rounded-lg p-3 space-y-2">
                    <div className="text-sm font-medium text-gray-700">{(t && t("label_quien_recibe_entrega")) || "Quién recibe entrega"}</div>
                    <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                        {item.quienRecibeEntregaSelected.map((opt, i) => <li key={i}>{opt.descripcion}</li>)}
                    </ul>
                </div>
            );
        }
        return (
            <div key={key} className="border border-gray-200 rounded-lg p-3 text-sm text-gray-600">
                <span className="font-medium">{item.key}</span>
                {item.type && <span className="text-gray-500"> ({item.type})</span>}
            </div>
        );
    };

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 p-4">
            <div className="bg-white rounded-lg shadow-xl border border-gray-200 w-full max-w-2xl max-h-[85vh] flex flex-col">
                <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200">
                    <h3 className="text-lg font-semibold text-gray-900">{(t && t("label_detalle_workflow"))} - {rowSelected?.numeroDocumento ?? ""}</h3>
                    <button type="button" className="p-1 text-gray-600 hover:text-gray-900" onClick={onClose} aria-label={(t && t("label_cerrar")) || "Cerrar"}>
                        <X className="h-5 w-5" />
                    </button>
                </div>

                <div className="flex border-b border-gray-200 px-4 gap-1 shrink-0">
                    <button
                        type="button"
                        onClick={() => setActiveTab(0)}
                        className={`px-4 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${activeTab === 0 ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}
                    >
                        {t("label_workflow")}
                    </button>
                    {tabs.map((tab, i) => (
                        <button
                            key={tab.id}
                            type="button"
                            onClick={() => setActiveTab(i + 1)}
                            className={`px-4 py-3 text-sm font-medium border-b-2 -mb-px transition-colors ${activeTab === i + 1 ? "border-blue-500 text-blue-600" : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"}`}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>

                <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
                    {activeTab === 0 && (
                        <div className="p-4 overflow-auto space-y-3">
                            {loading ? (
                                <div className="text-sm text-gray-500">{(t && t("label_cargando")) || "Cargando..."}</div>
                            ) : displayItems.length === 0 ? (
                                <div className="text-sm text-gray-500">{(t && t("label_sin_workflow")) || "Sin datos de workflow"}</div>
                            ) : (
                                displayItems.map((item, index) => renderWorkflow(item, index))
                            )}
                        </div>
                    )}
                    {activeTab === 1 && (
                        <div className="p-4 overflow-auto space-y-3">
                            <MapaInicioFin
                                start={inicioRuta}
                                end={finRuta}
                                historico={historicoCoords}
                                tag={t}
                            />
                        </div>
                    )}
                </div>

                <div className="px-4 py-3 border-t border-gray-200 flex justify-end">
                    <button type="button" className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm" onClick={onClose}>
                        {(t && t("label_cerrar")) || "Cerrar"}
                    </button>
                </div>
            </div>
        </div>
    );
}
